(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-proof-block"] && !Shopify.designMode) return;
  try {
    
(function () {

  /* ── FEED: kaç saniyede bir değişsin (ms) ── */
  var FEED_INTERVAL = 12000; /* 12 saniye */

  /* ── SAYAÇ: kaç ms'de bir +1 artsın (1.5 dk = 90 sn) ── */
  var COUNT_INTERVAL = 90000;

  /* ── SİPARİŞ LİSTESİ ── */
  var orders = [
    { name:'Ayşe K.',    city:'İstanbul', pkg:'2 Çift', mins:118 },
    { name:'Beren B.',   city:'Antalya',  pkg:'1 Çift', mins:94  },
    { name:'Esma K.',    city:'İzmir',    pkg:'2 Çift', mins:71  },
    { name:'Zeynep A.',  city:'Bursa',    pkg:'2 Çift', mins:53  },
    { name:'Elif T.',    city:'Ankara',   pkg:'1 Çift', mins:38  },
    { name:'Selin M.',   city:'Kocaeli',  pkg:'2 Çift', mins:22  },
    { name:'Hande Y.',   city:'Adana',    pkg:'1 Çift', mins:11  },
    { name:'Merve C.',   city:'İzmir',    pkg:'2 Çift', mins:4   },
    { name:'Dilek Ş.',   city:'Trabzon',  pkg:'2 Çift', mins:2   },
    { name:'Gül N.',     city:'Konya',    pkg:'1 Çift', mins:1   },
    { name:'Tuğba E.',   city:'Gaziantep',pkg:'2 Çift', mins:0   },
    { name:'Melek D.',   city:'İstanbul', pkg:'1 Çift', mins:0   },
  ];

  var colors = [
    '#3b82f6','#10b981','#f97316','#8b5cf6',
    '#ec4899','#f59e0b','#14b8a6','#ef4444',
    '#06b6d4','#84cc16','#a855f7','#fb923c'
  ];

  var VISIBLE = 3;
  var cursor  = 0;

  var feedEl  = document.getElementById('spFeed');
  var orderEl = document.getElementById('spOrderCount');
  var count   = orderEl ? parseInt(orderEl.textContent, 10) : 47;

  /* Sayfa her açıldığında başlangıç sayacına 0-8 arası rastgele ekle */
  count = count + Math.floor(Math.random() * 9);
  if (orderEl) orderEl.textContent = count;

  function timeLabel(m) {
    if (m === 0) return 'Az önce';
    if (m < 60)  return m + ' dk önce';
    var h = Math.floor(m / 60), r = m % 60;
    return h + ' sa' + (r ? ' ' + r + ' dk' : '') + ' önce';
  }
  function initials(n) {
    return n.split(' ').map(function(w){ return w[0]; }).join('').slice(0,2);
  }

  function renderFeed(highlightFirst) {
    if (!feedEl) return;
    feedEl.innerHTML = '';
    for (var i = 0; i < VISIBLE; i++) {
      var idx = (cursor + i) % orders.length;
      var o   = orders[idx];
      var div = document.createElement('div');
      div.className = 'sp-item' + (highlightFirst && i === 0 ? ' sp-new' : '');
      var c = colors[idx % colors.length];
      div.innerHTML =
        '<div class="sp-avatar" style="background:' + c + '" aria-hidden="true">' + initials(o.name) + '</div>' +
        '<div class="sp-item-body">' +
          '<div class="sp-item-name">' + o.name + '</div>' +
          '<div class="sp-item-meta">\uD83D\uDCCD ' + o.city + '</div>' +
        '</div>' +
        '<div class="sp-item-right">' +
          '<span class="sp-pkg">' + o.pkg + '</span>' +
          '<span class="sp-time">' + timeLabel(o.mins) + '</span>' +
        '</div>';
      feedEl.appendChild(div);
    }
  }

  function rotateFeed() {
    cursor = (cursor + 1) % orders.length;
    renderFeed(true);
    setTimeout(function () {
      var el = feedEl && feedEl.querySelector('.sp-item.sp-new');
      if (el) el.classList.remove('sp-new');
    }, 2500);
  }

  function tickCount() {
    count++;
    if (orderEl) orderEl.textContent = count;
  }

  renderFeed(false);
  setInterval(rotateFeed, FEED_INTERVAL);
  setInterval(tickCount,  COUNT_INTERVAL);

})();

  } catch(e) { console.error(e); }
})();
})();
